import driver from './driver';
import error from './error';
import profile from './profile';
import rating from './rating';
import ratingSelf from './ratingSelf';
import s3 from './s3';
import series from './series';
import track from './track';

const api = {
  driver,
  error,
  profile,
  rating,
  ratingSelf,
  s3,
  series,
  track,
};

export default api;
